import { render, staticRenderFns } from "./modtopbar.vue?vue&type=template&id=0a91a89b&scoped=true"
import script from "./modtopbar.vue?vue&type=script&lang=js"
export * from "./modtopbar.vue?vue&type=script&lang=js"
import style0 from "./modtopbar.vue?vue&type=style&index=0&id=0a91a89b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a91a89b",
  null
  
)

export default component.exports